import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";
import { useWidth } from "@/utils/resize";
import { watchDom } from "@/watch";
import buriedsdk from "@/utils/zz-buried/index";
import Matrix from "@@/matrix";
import Performance from "@@/matrix/performance";
const PcFreestart = dynamic(import("@home3/pc/Freestart"));

import banner from "@images/features/shops/banner.png";
import sec1 from "@images/features/shops/sec1.png";
import sec2 from "@images/features/shops/sec2.png";
import sec3 from "@images/features/shops/sec3.png";

type Props = {};

let watchDoms: any = "";
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("features");
  const dom: any = useRef();
  const { width, display } = useWidth();

  const mobileUrl = process.env.mobileUrl;
  const pcUrl = process.env.portalUrl;

  const list = [
    {
      title: t("Page Shops Content1 Title"),
      title2: "",
      tip: t("Page Shops Content1 Desc"),
      btnWords: 'Explore Now',
      bg: "#fff",
      img: sec1,
      alt: t("Page Shops Content1 Title"),
      pcUrl: pcUrl + "/discovery/shop",
      mUrl: '/'
    },
    {
      title: t("Page Shops Content2 Title"),
      title2: "",
      tip: t("Page Shops Content2 Desc"),
      bg: "linear-gradient(135deg, #F6FEFF 0%, #FFEFEF 100%);",
      img: sec2,
      alt: t("Page Shops Content2 Title"),
      pcUrl: pcUrl + "/discovery/shop",
      mUrl: '/'
    },
    {
      title: t("Page Shops Content3 Title"),
      title2: "",
      tip: t("Page Shops Content3 Desc"),
      btnWords: 'Start Free Trial',
      bg: "#ff",
      img: sec3,
      alt: t("Page Shops Content3 Title"),
      pcUrl: pcUrl + "/shop/sales?name=rising",
      mUrl: '/'
    },
  ];
  const handleJump = () => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `Start Free Trial按钮`,
      URL: process.env.publicApiDomain,
    });
  };

  useEffect(() => {
    if (process.browser) {
      if (dom.current) {
        if (watchDoms) clearInterval(watchDoms);
        watchDoms = watchDom();
      }
    }
  }, [dom]);

  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("Page Shops Title")}</title>
          <meta name="keywords" content={t("Page Shops Keywords")}></meta>
          <meta name="description" content={t("Page Shops Description")} />
          <script src="/js/jq.js" async />
          <script src="/js/kefu53.js" async />
        </Head>
        <div className={styles.down} ref={dom}>
          <div className={styles.center + " defeaultContainer"}>
            <div className={styles.banner}>
              <div className={styles.info + " animate-box"}>
                <h2 className={styles.title + " ant"}>{t("Page Shops Banner Title")}</h2>
                <p className={styles.desc + " ant"}>
                  {t("Page Shops Banner Desc")}
                </p>
                <a
                  rel="noreferrer"
                  onClick={handleJump}
                  href={
                    width > 1024
                      ? pcUrl + "/shop/sales?name=rising "
                      : mobileUrl + "?from=chaodian_jiejuefangan"
                  }
                  target="_blank"
                  className={styles.btn + " ant"}
                >
                  {t("Start Free Trial")}
                </a>
              </div>
              <div className={styles.imgWrap + " animate-box"}>
                <Image
                  className="ant"
                  width={592}
                  height={626}
                  src={banner}
                  alt=""
                ></Image>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Matrix list={list}></Matrix>
          <Performance name="Analyze Shops"></Performance>
          <PcFreestart></PcFreestart>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        "home",
        "common",
        "nav",
        "footer",
        "features",
      ])),
      context: {
        locale,
        req: {
          headers: context.req.headers,
        },
      },
    },
  };
};

export default Index;
